import { render, staticRenderFns } from "./EmployeeFormView.vue?vue&type=template&id=1f50b6c4&scoped=true&"
import script from "./EmployeeFormView.vue?vue&type=script&lang=js&"
export * from "./EmployeeFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f50b6c4",
  null
  
)

export default component.exports